import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import styles from './LinkWithLayers.module.scss';

type themes = 'violet' | 'black';

interface Props extends React.ComponentProps<typeof Link> {
    className?: string;
    theme?: themes;
    second?: string;
    children: React.ReactNode | React.ReactNode[];
    onClick?: () => void;
    disabled?: boolean;
}

export const LinkWithLayers: React.FC<Props> = ({
    theme = 'violet',
    className,
    second,
    children,
    onClick,
    disabled,
    ...rest
}) => {
    const themeClass = styles[theme];

    return (
        <Link
            onClick={onClick}
            className={classNames(className, disabled ? 'disabled' : undefined, styles.link, themeClass)}
            {...rest}
        >
            <div className={classNames(second, styles.layer, themeClass)}>{children}</div>
        </Link>
    );
};
